import type { ReactNode } from 'react';
import {
  ArrowDownloadRegular,
  ArrowSyncRegular,
  BookOpenRegular,
  BotSparkleRegular,
  BrainRegular,
  ChartMultipleRegular,
  CheckmarkCircleRegular,
  ClipboardRegular,
  AddRegular,
  DocumentRegular,
  ErrorCircleRegular,
  LinkRegular,
  PuzzlePieceRegular,
  RulerRegular,
  RocketRegular,
  SearchRegular,
  SettingsRegular,
  SparkleRegular,
  WarningRegular,
  WrenchScrewdriverRegular,
  WrenchRegular,
} from '@fluentui/react-icons';

const statusIconByEmoji: Record<string, ReactNode> = {
  '🚀': <RocketRegular aria-hidden="true" />,
  '🔍': <SearchRegular aria-hidden="true" />,
  '📊': <ChartMultipleRegular aria-hidden="true" />,
  '🔨': <WrenchRegular aria-hidden="true" />,
  '💭': <BrainRegular aria-hidden="true" />,
  '📥': <ArrowDownloadRegular aria-hidden="true" />,
  '📋': <ClipboardRegular aria-hidden="true" />,
  '🧩': <PuzzlePieceRegular aria-hidden="true" />,
  '🔄': <ArrowSyncRegular aria-hidden="true" />,
  '🔧': <WrenchRegular aria-hidden="true" />,
  '🛠️': <WrenchScrewdriverRegular aria-hidden="true" />,
  '🔁': <ArrowSyncRegular aria-hidden="true" />,
  '📚': <BookOpenRegular aria-hidden="true" />,
  '📐': <RulerRegular aria-hidden="true" />,
  '📄': <DocumentRegular aria-hidden="true" />,
  '🔎': <SearchRegular aria-hidden="true" />,
  '🔗': <LinkRegular aria-hidden="true" />,
  '⚙️': <SettingsRegular aria-hidden="true" />,
  '➕': <AddRegular aria-hidden="true" />,
  '📖': <BookOpenRegular aria-hidden="true" />,
  '✅': <CheckmarkCircleRegular aria-hidden="true" />,
  '✨': <SparkleRegular aria-hidden="true" />,
  '⚠️': <WarningRegular aria-hidden="true" />,
  '❌': <ErrorCircleRegular aria-hidden="true" />,
};

export const getStatusIcon = (emoji: string): ReactNode =>
  statusIconByEmoji[emoji] ?? <BotSparkleRegular aria-hidden="true" />;

export const parseStatusMessage = (text: string): { emoji: string; message: string } => {
  const emojiMatch = text.match(/^(\p{Extended_Pictographic}\uFE0F?)\s*/u);
  if (!emojiMatch?.[1]) {
    return { emoji: '', message: text };
  }

  return {
    emoji: emojiMatch[1],
    message: text.slice(emojiMatch[0].length).trim(),
  };
};
